module.exports = __webpack_public_path__ + "static/media/Element_10_treatments.34bdb0e5.svg";